export default (set, get, key) => get()?.skuDimensions[key];
